import React, { useEffect } from "react";
import { getListAction } from "../../../../state/usecase/care_recipient/actions";
import { RegistrationStatus, useRegistrationStatus } from "../../../provider/RegistrationStatusProvider";
import { useCareRecipientList } from "../../../hooks/care_recipient/useCareRecipientList";
import { useAppDispatch } from "../../../../state/store";
import InformationButton from "./InformationButton";
import AccountButton from "./AccountButton";
import CareRecipientSelectButton from "./CareRecipientSelectButton";
import HelpButton from "./HelpButton";

export function Menus() {
    const dispatch = useAppDispatch();

    const registered = useRegistrationStatus();
    const { careRecipients } = useCareRecipientList();

    useEffect(() => {
        if (registered === RegistrationStatus.REGISTERED) {
            dispatch(getListAction());
        }
    }, [dispatch, registered]);

    const renderNavButtons = () => {
        if (registered !== RegistrationStatus.REGISTERED) return null;
        return (
            <>
                <HelpButton/>
                <InformationButton/>
                <AccountButton/>
            </>
        );
    };

    return (
        <div className={"menus"}>
            <div className={"menus__actions"}>
                <CareRecipientSelectButton careRecipients={careRecipients}/>
                <div className={"nav_button_area"}>
                    {renderNavButtons()}
                </div>
            </div>
        </div>
    );
}
